import { css } from '@emotion/react';
import { typography, colors, boxShadow } from 'component-library';

const Body = css`
  body.shepherd-target {
    overflow: hidden;
    padding-right: 12px;
  }
`;

const Button = css`
  .shepherd-button {
    font-family:
      StenaSans,
      -apple-system,
      BlinkMacSystemFont,
      sans-serif;
    border: none;
    user-select: none;
    transition: background-color 0.1s ease-in-out;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 2.5px;
    text-transform: uppercase;
    padding: 12px 32px;
    background-color: #327ea5;
    color: #ffffff;
    cursor: pointer;
    margin: 0;
    border-radius: 0;
  }

  .shepherd-button:not(:disabled):hover {
    background-color: #155d7f;
  }

  .shepherd-button:disabled {
    cursor: default;
  }
`;

const SecondaryButton = css`
  .shepherd-button.shepherd-button-secondary {
    font-family:
      StenaSans,
      -apple-system,
      BlinkMacSystemFont,
      sans-serif;
    user-select: none;
    transition: background-color 0.1s ease-in-out;
    cursor: pointer;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 2.5px;
    text-transform: uppercase;
    padding: 12px 32px;
    background-color: transparent;
    color: #327ea5;
    margin: 0;
  }

  .shepherd-button.shepherd-button-secondary:not(:disabled):hover,
  .shepherd-link-bordered:hover {
    color: #155d7f;
    background-color: transparent;
  }
`;

const ShepherdModal = css`
  &.shepherd-element,
  .shepherd-header,
  .shepherd-text,
  .shepherd-footer {
    padding: 0;
  }

  &.shepherd-element {
    max-width: none;
    width: min-content;
    box-shadow: ${boxShadow};

    max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .shepherd-content {
    padding: 32px;
    display: flex;
    flex-direction: column;
    background-color: ${colors.base.white};
    width: 'min-content';
    min-width: 650px;
    border-radius: 0;
    position: relative;
  }
`;

const ShepherdHeading = css`
  .shepherd-text h3 {
    ${typography.heading.desktop.large};
    margin-bottom: 24px;
  }
`;

const ShepherdText = css`
  .shepherd-text {
    margin-bottom: 32px;

    p {
      ${typography.body.large};
      margin-bottom: 32px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    img {
      margin-bottom: 32px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    // THe fuck is this?
    /* a {
      display: inline-block;
      cursor: pointer;
      font-family:
        StenaSans,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 2.5px;
      text-transform: uppercase;
      text-decoration: none;
      border: 1px solid #327ea5;
      padding: 12px 32px;
      background-color: transparent;
      color: #327ea5;
    } */
  }
`;

const ShepherdFooter = css`
  .shepherd-footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
`;

const ShepherdCancel = css`
  .shepherd-cancel-icon {
    font-size: 32px;
    display: flex;
    position: absolute;
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    transition: background-color 0.1s ease-in-out 0s;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    color: rgb(30, 30, 30);
  }

  .shepherd-cancel-icon:hover {
    background-color: rgb(230, 230, 230);
  }

  .shepherd-has-title .shepherd-content .shepherd-cancel-icon {
    color: hsla(0, 0%, 50%, 0.75);
  }

  .shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {
    color: rgba(0, 0, 0, 0.75);
  }
`;

const Pictogram = css`
  .pictograms {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin: 24px;
    margin-top: 0;
  }

  .pictogram {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 24px;
  }

  .pictogram img {
    margin: 0;
  }
`;

const ShepherdOverlay = css`
  .shepherd-modal-overlay-container.shepherd-modal-is-visible {
    transition:
      all 0.3s ease-out,
      width 0s 0s,
      height 0s 0s,
      opacity 0.3s 0s !important;
  }
`;

export const styles = css`
  ${Body}
  ${ShepherdOverlay}

  .stena-recycling {
    ${Button}
    ${SecondaryButton}
    ${ShepherdModal}
    ${ShepherdHeading}
    ${ShepherdText}
    ${ShepherdFooter}
    ${ShepherdCancel}
    ${Pictogram}
  }
`;
